import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import gpickr from '@/components/mapv2/gpickr';
import sliderInput from '@/components/mapv2/sliderinput';
export default {
  components: {
    gpickr,
    sliderInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      form: {
        linetype: 1,
        lineDash: [4, 2]
      },
      lineform: {
        width: 1,
        linetype: 1,
        color: 'rgba(0,0,0,0.5)',
        lineDash: [4, 2]
      },
      max: 20
    };
  },
  watch: {
    value: {
      handler(val) {
        if (Object.keys(val).length > 0) {
          Object.keys(val).forEach(elem => {
            elem === 'lineDash' ? this.getDashType(val[elem]) : this.form[elem] = elem === 'width' ? Number(val[elem]) : val[elem];
          });
        } else {
          this.styleback();
        }
      },
      deep: true
    }
  },
  mounted() {
    if (Object.keys(this.value).length === 0) {
      this.styleback();
    }
  },
  methods: {
    drawLineChange(val, type) {
      if (type === 'color') {
        this.form.color = val;
      }
      if (type === 'width') {
        this.form.width = val;
      }
      if (type === 'type') {
        let borderstyle = [];
        switch (val) {
          case 2:
            borderstyle = [2, 2, 4];
            break;
          case 3:
            borderstyle = [4, 2];
            break;
          case 4:
            borderstyle = [2, 2];
            break;
          default:
            borderstyle = [];
            break;
        }
        this.form.lineDash = borderstyle;
      }
      this.styleback();
    },
    // type 0 默认返回
    styleback() {
      if (Object.keys(this.form).length === 0) this.form = {
        ...this.lineform
      };
      let style = {
        ...this.form
      };
      delete style.linetype;
      // console.log(`this.form`, this.form)
      this.$emit('linestyleback', style);
    },
    getDashType(val) {
      switch (JSON.stringify(val)) {
        case JSON.stringify([2, 2, 4]):
          this.form.linetype = 2;
          break;
        case JSON.stringify([4, 2]):
          this.form.linetype = 3;
          break;
        case JSON.stringify([2, 2]):
          this.form.linetype = 4;
          break;
        default:
          this.form.linetype = 1;
          break;
      }
    }
  }
};